import type { Selection } from "../types";

export function selectionHasRightPanelTarget(selection: Selection): boolean {
  return selection.kind !== "email";
}

export function selectionHasSettingsPanelTarget(
  selection: Selection,
  selectedBlockIdsLength: number,
): boolean {
  if (selection.kind === "block" && selectedBlockIdsLength > 1) {
    return false;
  }

  return selectionHasRightPanelTarget(selection);
}
